import TableCellContentOfCount from "../../Table/TableCell/TableCellContentOfCount";
import AppTooltip, { AppTooltipProps } from "../../Tooltip/AppTooltip";

interface Props {
  count: number | null | undefined;
  tooltipProps?: Omit<AppTooltipProps, "children">;
}
export function ChatMessageCountInTableCell({ count, tooltipProps }: Props) {
  return (
    <AppTooltip
      {...tooltipProps}
      isEnabled={tooltipProps?.isEnabled ?? !!tooltipProps}
      title={tooltipProps?.title ?? ""}
    >
      <TableCellContentOfCount
        count={count ?? 0}
        variant={(count ?? 0) > 0 ? "filled" : "outlined"}
        color={(count ?? 0) > 0 ? "primary" : "default"}
        size='medium'
      />
    </AppTooltip>
  );
}
